






















import { Vue, Component, Prop } from "vue-property-decorator";

import { TextArea } from "@netex/inputs";

import Preloader from "@/components/common/Preloader.vue";
import OrderInfo from "@/components/common/OrderInfo.vue";
import Title from "@/components/organisms/Modal/Title.vue";

import { cartModule, personalModule } from "@/plugins/store-accessors";

@Component({
  components: { Title, Preloader, OrderInfo, TextArea },
})
export default class Confirm extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly loading!: boolean;

  @Prop({ type: String, default: "" })
  readonly error!: boolean;

  name!: string;
  comment = "";

  get getUserName() {
    return personalModule.getUserName;
  }

  get getOrderSum() {
    return cartModule.order.reduce(
      (acc, obj) => acc + (obj.total_price || 0),
      0,
    );
  }

  get getOrderQuantity() {
    return cartModule.order.reduce((acc, obj) => acc + (obj.quantity || 0), 0);
  }

  get getOrderProducts() {
    return cartModule.order
      .filter((el) => el.product)
      .map((item) => item.product);
  }

  get info() {
    return {
      name: this.name,
      products: this.getOrderProducts,
      quantity: this.getOrderQuantity,
      sum: this.getOrderSum,
    };
  }

  setComment(name: string, value: string) {
    this.comment = value;
  }
}
